var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsLeasingSpaceAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.11133 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#005fe3",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.6966 12.7181c0-.7569-.1488-1.4904-.4401-2.1836-.2828-.66761-.6868-1.2672-1.2013-1.78174s-1.1141-.91852-1.7818-1.20131c-.691-.29341-1.4266-.44012-2.1836-.44012-.7569 0-1.4904.14883-2.1836.44012-.6676.28279-1.2672.68677-1.7817 1.20131-.5146.51454-.9186 1.11413-1.2014 1.78174-.2934.691-.4401 1.4267-.4401 2.1836 0 .9462.2382 1.8732.691 2.6982l-6.71239 6.706c-.15521.1553-.20412.3913-.10844.6145.01914.0468.05103.0893.08718.1254l1.50323 1.5033c.03614.0361.07866.0659.12544.0872.22325.0956.45926.0489.61447-.1085l.92911-.9291 1.3374 1.3373c.0362.0362.0787.0659.1255.0872.2232.0957.4592.0489.6144-.1084l1.482-1.482c.0361-.0361.0659-.0787.0872-.1254.0956-.2233.0489-.4593-.1085-.6145l-1.3161-1.3161 3.555-3.5572c.8229.4529 1.752.6911 2.6982.6911.7569 0 1.4904-.1489 2.1836-.4402.6676-.2827 1.2672-.6867 1.7818-1.2013.5145-.5145.9185-1.1141 1.2013-1.7817.2934-.6953.4422-1.4288.4422-2.1858zm-3.6421 1.9668c-.5252.5251-1.2248.8143-1.9668.8143s-1.4416-.2892-1.9667-.8143c-.5252-.5252-.8165-1.2247-.8165-1.9668 0-.7441.2892-1.4415.8144-1.9667.5251-.5252 1.2247-.81434 1.9667-.81434s1.4416.28914 1.9667.81434c.5252.5252.8144 1.2247.8144 1.9667.0042.7421-.285 1.4416-.8122 1.9668z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsLeasingSpaceAvailable);
export default __webpack_public_path__ + "static/media/AmenitiesIconsLeasingSpaceAvailable.ce7668477ad434c33327f446146fe08b.svg";
export { ForwardRef as ReactComponent };